const track = (event, data) => {
    if (typeof window === 'undefined' || !window.umami) return
    window.umami.track(event, data)
}

export const trackDownload = (platform) => track(`download-${platform}`)

export const trackCheckout = (plan) => track('checkout-start', { plan })

export const trackPurchase = ({ value, currency, plan, orderId }) =>
    track('purchase', { value, currency, plan, orderId })
